import { ISchema } from 'yup';
import { describeSchema, type IValidationDescription } from './describeSchema';

interface ITraverseOptions {
  value: any;
  context?: any;
}

export function traverseSchema(
  schema: ISchema<any>,
  options: ITraverseOptions,
  cb: (schema: IValidationDescription) => void,
) {
  const desc = describeSchema(schema, options);
  const queue = [desc];
  while (queue.length) {
    const item = queue.shift()!;
    cb(item);
    if (item.type === 'array') {
      queue.push(...item.schemas);
    }
    if (item.type === 'object') {
      queue.push(...Object.values(item.schemas));
    }
  }
}
